export const getters = {
  getQueuedCount: $state => $state.count,
};
